import React, { useState, useEffect } from 'react';
import styles from './FilterSection.module.css';
import CategoryPicker from './CategoryPicker';
import PeriodPicker from './PeriodPicker';
import { useModal } from './ModalProvider';
import filters from '../assets/filter.png';
import { LocateMe } from './LocateMe';
import { useSharedState } from '../hooks/useSharedState';
import { FilterModal } from './FilterModal';
import { useCategories } from '../hooks/useCategories';
import { BrowseFilterState, getAppliedFilterChips, getMobileFilterSummary } from '../utils/filterUtils';
import { DEFAULT_CITY } from '../utils/GlobalUtil';

interface FilterSectionProps {
    
}

const FilterSection: React.FC<FilterSectionProps> = () => {

    const [categories, setCategories] = useSharedState('categories', '');
    const [free, setFree] = useSharedState('free', '');
    const [period, setPeriod] = useSharedState('period', '');
    const [time, setTime] = useSharedState('time', '');
    const [city, setCity] = useSharedState('city', DEFAULT_CITY);
    const [venue, setVenue] = useSharedState('venue', '');
    const [latitude, setLatitude] = useSharedState('latitude', '');
    const [longitude, setLongitude] = useSharedState('longitude', '');
    const [isScrolled, setIsScrolled] = useState(false);

    const { show, hide } = useModal();
    const { categories: availableCategories } = useCategories();

    const filterState: BrowseFilterState = { categories, free, period, time, city, venue, latitude, longitude };
    const categoryNameBySlug = new Map(availableCategories.map((category) => [category.slug, category.name]));
    const mobileSummary = getMobileFilterSummary(getAppliedFilterChips(filterState, categoryNameBySlug));

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 250) {//was 50 before
                setIsScrolled(true);
                //setIsExpanded(false); // Minimize if scrolled
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleFree = () => {
        setFree(free == '1' ? '0' : '1');
    };

    const applyMobileFilters = (nextFilters: BrowseFilterState) => {
        setCategories(nextFilters.categories);
        setFree(nextFilters.free);
        setPeriod(nextFilters.period);
        setTime(nextFilters.time);
        setCity(nextFilters.city);
        setVenue(nextFilters.venue);
        setLatitude(nextFilters.latitude);
        setLongitude(nextFilters.longitude);
    };

    return (
        <div className={[styles.filterSection, isScrolled ? styles.scrolled : ''].join(' ')}>

            <div className={styles.filterContentDesktop}>
                <CategoryPicker selectedCategories={categories.split(';')} onChange={(cats) => setCategories(cats.join(';'))} />
                <LocateMe />
                <button type="button" className={[styles.freeButton, free == '1' ? styles.selected : ''].join(' ')} onClick={toggleFree} aria-pressed={free == '1'}>Gratuit {free=='1'&&<span className={styles.filterCheckBadge} aria-hidden="true">✓</span>}</button>
                <PeriodPicker />
            </div>

            <div className={styles.filterContentMobile}>
                
                    <button type="button" className={styles.filterMinimized} onClick={() => {
                        show(<FilterModal hide={hide} filters={filterState} onApply={applyMobileFilters} />, {
                            backgroundColor: "#f3efe6",
                            textColor: "var(--color-accent-dark)",
                            mobileFullscreen: true
                        });
                    }}>
                        <div className={styles.filterBtn}>
                            <div>
                                <img src={filters} width="20" height="20" alt="Filtres"/>
                                Filtres
                            </div>
                            <div>{mobileSummary}</div>
                        </div>
                    </button>
                
            </div>
        </div>
    );
};

export default FilterSection;
